import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAddKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"add-keyframe, rhombus"} maskId="square-filled-radius-0-stroke-1-IconAddKeyframe"><path fillRule="evenodd" clipRule="evenodd" d="M1.29297 12L12.0001 1.29297L22.7072 12L12.0001 22.7072L1.29297 12ZM12.5 8.5H11.5V11.5H8.5V12.5H11.5V15.5H12.5V12.5H15.5V11.5H12.5V8.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAddKeyframe;
